import { useContext } from "react"

import { JOB_ADS_FO_ALGOLIA_INDEX_FROM_UNLEASH } from "@/modules/jobAds/client/constants/flags"
import { ServerContext } from "@/modules/server/context"

export const useAlgoliaIndexNameFromUnleash = (): string | undefined => {
  const context = useContext(ServerContext)
  const activeFlags = context?.activeFlags
  const algoliaIndexFromUnleash = activeFlags?.find(({ name }) => {
    return name === JOB_ADS_FO_ALGOLIA_INDEX_FROM_UNLEASH
  })?.variant

  return algoliaIndexFromUnleash
}
